import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import type { InferOutput } from 'valibot'
import { faDesktop, faMoon, faSun } from '@fortawesome/pro-duotone-svg-icons'
import { picklist } from 'valibot'

export const colorModeSchema = picklist([
  'system',
  'light',
  'dark',
])

export type ColorMode = InferOutput<typeof colorModeSchema>

export const COLOR_MODE_OPTIONS = [
  {
    value: 'system',
    label: 'Automatisk',
    icon: faDesktop,
  },
  {
    value: 'light',
    label: 'Lys',
    icon: faSun,
  },
  {
    value: 'dark',
    label: 'Mørk',
    icon: faMoon,
  },
] as const satisfies Options<string, { icon: IconDefinition }>

export const themeSchema = picklist([
  'blurple',
  'moss',
  'carbon',
])

export type Theme = InferOutput<typeof themeSchema>

export const THEME_OPTIONS = [
  {
    value: 'blurple',
    label: 'Lilla',
  },
  {
    value: 'moss',
    label: 'Grønn',
  },
  {
    value: 'carbon',
    label: 'Sort',
  },
] as const satisfies Options<string>
